import { Box } from 'shared/ui/Box';
import { Skeleton } from 'shared/ui/Skeleton';
import { Flex } from 'shared/ui/StyledComponents';
import { CurrentUserSkeleton } from 'entities/currentUser';
import { Logout } from 'features/logout';

import { LinksContainerStyled, LinkStyled, LogoStyled, NavPanelStyled, RootStyled, UserPanelStyled } from './styled';

export const SidebarSkeleton = () => (
  <RootStyled>
    <LogoStyled>SD TECH</LogoStyled>
    <NavPanelStyled>
      <LinksContainerStyled justifyContent='flex-start'>
        <Box>
          <Flex flexDirection='column' gap={8}>
            <LinkStyled mx={6} my={7} as='div'>
              <Skeleton width='100%' height='30px' />
            </LinkStyled>
            <LinkStyled mx={6} my={7} as='div'>
              <Skeleton width='100%' height='30px' />
            </LinkStyled>
            <LinkStyled mx={6} my={7} as='div'>
              <Skeleton width='100%' height='30px' />
            </LinkStyled>
            <LinkStyled mx={6} my={7} as='div'>
              <Skeleton width='100%' height='30px' />
            </LinkStyled>
            <LinkStyled mx={6} my={7} as='div'>
              <Skeleton width='100%' height='30px' />
            </LinkStyled>
            <LinkStyled mx={6} my={7} as='div'>
              <Skeleton width='100%' height='30px' />
            </LinkStyled>
          </Flex>
        </Box>
      </LinksContainerStyled>
      <UserPanelStyled as='div'>
        <CurrentUserSkeleton />
        <Logout />
      </UserPanelStyled>
    </NavPanelStyled>
  </RootStyled>
);
